import React, { Component } from 'react';
import { Link } from 'react-router';


var BlockField = React.createClass({

  render: function(){
    if(this.props.data){
      if(this.props.type == 'uniteField'){
        if(this.props.link){
          if(this.props.typeLink == 'native'){
            return(
              <a style={this.props.style || {}} href={this.props.link} className="blockField"><div className="uniteField">{this.props.data || ''}</div></a>
            );
          }else{
            return(
              
                  <Link style={this.props.style || {}} className="SelectSpecialtiesOpen top" to={this.props.link}>{this.props.data || ''}</Link>
              
            );
          }

        }else{
          return(
            <div style={this.props.style || {}} className="blockField"><div className="uniteField">{this.props.data || ''}</div></div>
          );
        }
      }else{
        if(this.props.link){
          if(this.props.typeLink == 'native'){
            return(
              <a style={this.props.style || {}} href={this.props.link} className="blockField">
                <div className="nameField">{this.props.name}</div>
                <div className="dataField">{this.props.data}</div>
              </a>
            );
          }else{
            return(
              <Link style={this.props.style || {}} className="blockField" to={this.props.link}>
                <div className="nameField">{this.props.name}</div>
                <div className="dataField">{this.props.data}</div>
              </Link>
            );
          }

        }else{
          return(
            <div onClick={this.props.onClick || function(){}} style={this.props.style || {}} className="blockField">
              <div className="nameField">{this.props.name}</div>
              <div className="dataField">{this.props.data}</div>
            </div>
          );
        }
      }
    }else{
      return null;
    }
  }
});

export default BlockField;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Profile/components/BlockField/index.jsx
 **/